module.exports = __webpack_public_path__ + "static/media/store_x5.08a8e4e7.svg";